import { useTranslation } from 'react-i18next'
import Img from './Img'

const ListItems = ({
  namePrefix,
  size,
  startPosition = 1,
  type = 'advantage',
}) => {
  const { t } = useTranslation()
  const images =
    type === 'advantage'
      ? {
          src: 'images/login/grin_ico_advantages_checkmark.svg',
          alt: 'Advantage',
        }
      : {
          src: 'images/login/grin_ico_disadvantages_checkmark.svg',
          alt: 'Disadvantage',
        }

  return (
    <ul className="columns-list">
      {[...Array(size).keys()].map((number) => (
        <li key={number.toString()}>
          <Img height={25} width={35} src={images.src} alt={images.alt} />
          {t(namePrefix + (number + startPosition))}
        </li>
      ))}
    </ul>
  )
}
export default ListItems
